import type { JSX } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, CardV2 as Card, EmptyState, type ISorted, Table } from '@feathr/components';
import { useLocalUrl } from '@feathr/extender/state';

import { useGoalDetailTopCampaigns } from './GoalDetailTopCampaigns.hooks';
import getGoalDetailTopCampaignsColumns, {
  type ITopCampaignRow,
} from './goalDetailTopCampaignsColumns';

import * as styles from './GoalDetailTopCampaigns.css';

function GoalDetailTopCampaigns(): JSX.Element {
  const { t } = useTranslation();
  const localUrl = useLocalUrl();
  const [sort, setSort] = useState<ISorted[]>([{ desc: true, id: 'total_conversions' }]);
  const { rows, isPending, hasError, hasMore } = useGoalDetailTopCampaigns({ limit: 10 });

  const columns = getGoalDetailTopCampaignsColumns(t, localUrl);

  return (
    <Card width={'full'}>
      {/* TODO: confirm "View all" destination with PM before enabling the link (#7890) */}
      <Card.Header title={t('Top contributing campaigns')}>
        {hasMore ? (
          <Button className={styles.link} link={'#'} type={'link'}>
            {t('View all')}
          </Button>
        ) : undefined}
      </Card.Header>
      <Card.Content>
        {!isPending && !hasError && rows.length === 0 ? (
          <EmptyState label={t('No contributing campaigns yet.')} theme={'white'} width={'full'} />
        ) : (
          <Table<ITopCampaignRow>
            columns={columns}
            idKey={'id'}
            isLoading={isPending}
            isPaginated={false}
            items={rows}
            onSortChange={setSort}
            sort={sort}
          />
        )}
      </Card.Content>
    </Card>
  );
}

export default GoalDetailTopCampaigns;
